define("shared/helpers/format-datetime", ["exports", "@ember/component/helper", "@ember/service", "later/utils/constants"], function (_exports, _helper, _service, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  /**
   * @module Helpers
   */
  /**
   * @class formatDateTime
   * @param {Integer} date The date in milliseconds to format
   * @param {String} format The date format to use: "short", "medium", or "long"
   */
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/service",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let formatDateTime = _exports.default = (_class = class formatDateTime extends _helper.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "locale", _descriptor, this);
    }
    compute(_ref) {
      let [date, format] = _ref;
      let displayFormat;
      switch (format) {
        case 'short':
          displayFormat = _constants.DATE_LENGTH.SHORT;
          break;
        case 'medium':
          displayFormat = _constants.DATE_LENGTH.MEDIUM;
          break;
        case 'long':
          displayFormat = _constants.DATE_LENGTH.LONG;
          break;
        default:
          displayFormat = _constants.DATE_LENGTH.MEDIUM;
      }
      return this.locale.formatDateTime(date, displayFormat);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});